import { englishCommaJoinStrings } from "@hex-insights/core";
import {
	graphTypeNames,
	MessageGroupNameFragment,
	truncateDisplayItems,
	UserGroupNameFragment,
	UserNameFragment,
} from "../../../Utilities";
import * as UserFormat from "../User";
import * as UserGroupFormat from "../UserGroup";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: MessageGroupNameFragment) {
	// Note: should agree (somewhat) with MessageGroupComponents.MessageGroupIcon

	if (instance.customName !== "") {
		return Fields.customName(instance.customName);
	}

	const users =
		instance.users.length === 1 && instance.userGroups.length === 0
			? instance.users
			: instance.users.filter((e) => !e.isCurrent); // remove current user unless is only user
	const { displayedItems, anyHidden, numHidden } = truncateDisplayItems([...instance.userGroups, ...users], 3);
	if (displayedItems.length > 0) {
		if (!anyHidden) {
			return englishCommaJoinStrings(displayedItems.map(memberName));
		}
		return `${memberName(displayedItems[0])}, ${memberName(displayedItems[1])}, and ${numHidden} others`;
	}

	return "";
}

function memberName(instance: UserGroupNameFragment | UserNameFragment) {
	if (instance.__typename === graphTypeNames.UserGroup) {
		return UserGroupFormat.name(instance);
	}
	return UserFormat.name(instance as UserNameFragment);
}
